import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Container } from 'reactstrap';
import DataDeleteLog from './DataDeleteLog';

const DeletionLog = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Settings" title="Delete Log" mainTitle="Delete Log" />
            <Container fluid={true}>
                <DataDeleteLog />
            </Container>
        </Fragment>
    )
}

export default DeletionLog